import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { Text, Button, TextInput } from 'react-orange-ui';

import Spinner from '../../Spinner/Spinner';
import LabelWithHelp from '../../Title/LabelWithHelp';
import LetterConfirm from '../../../containers/LetterConfirm';
import ApiService from '../../../services/ApiService';
import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';

class LetterView extends Component {
  state = {
    value: '',
    error: null,
    isFetching: false,
    isCheckingEligibility: true,
    letterIsSent: false,
  };

  async componentDidMount() {
    const { goToErrorPage } = this.props;

    try {
      const response = await ApiService.checkPendingLetter();

      if (response.data.data.letter) {
        goToErrorPage('letterIsPending');
      }
    } catch (err) {
      switch (err.response.status) {
        case 403:
          goToErrorPage('letterAttemptsExceeded');
          break;
        default:
          goToErrorPage();
      }
    }
    this.setState({ isCheckingEligibility: false });
  }

  /**
   * Change value state on change
   * Clear any error when exists on change
   * @param value
   */
  handleChange = (value) => {
    this.setState({
      value,
      error: null,
    });
  };

  /**
   * Set empty error on input blur
   * @param value
   */
  handleBlur = () => {
    const { value } = this.state;

    if (!value) {
      this.setState({ error: WordingService.getWording('errorMessage', 'noPostalCode') });
    }
  };

  /**
   * Send letter on submit
   * @param e
   */
  handleSubmit = async (e) => {
    e.preventDefault();

    const { value } = this.state;
    const { goToErrorPage } = this.props;

    // Send GA event
    TagService.sendAction('sendLetter');
    this.setState({ isFetching: true });

    if (!value) {
      this.setState({ error: WordingService.getWording('errorMessage', 'noPostalCode') });
    } else {
      try {
        const response = await ApiService.sendLetter({ postalCode: value });

        switch (response.status) {
          case 200:
            this.setState({ letterIsSent: true });
            break;
          default:
            goToErrorPage();
        }
      } catch (err) {
        switch (err.response.data.code) {
          case 403201:
            goToErrorPage('letterIsPending');
            break;
          case 412002:
            this.setState({ error: WordingService.getWording('errorMessage', 'noPostalCode') });
            break;
          case 412004:
          case 412201:
            this.setState({ error: WordingService.getWording('errorMessage', 'postalCodeIsIncorrect') });
            break;
          case 403202:
            goToErrorPage('letterAttemptsExceeded');
            break;
          default:
            goToErrorPage();
        }
      }
    }
    this.setState({ isFetching: false });
  };

  render() {
    const { value, isCheckingEligibility, isFetching, error, letterIsSent } = this.state;

    if (isCheckingEligibility) {
      return <Spinner />;
    }
    if (letterIsSent) {
      return <LetterConfirm />;
    }
    return (
      <form onSubmit={this.handleSubmit}>
        <Text id="letter-message">
          {WordingService.getWording('caption', 'fillPostalCode')}
        </Text>
        <br />
        <Row>
          <Col xs={12} sm={4}>
            <div>
              <LabelWithHelp
                id="postal-code-label"
                help={WordingService.getWording('caption', 'letterIndications')}
                htmlFor="postal-code-input"
              >
                {WordingService.getWording('caption', 'fillTwoDigitsPostalCode')}
              </LabelWithHelp>
              <TextInput
                id="postal-code-input"
                size="m"
                maxLength={2}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                errorMessage={error}
                errorWithIcon={true}
                value={value}
                valid={!error}
              />
              <br />
              <Button htmlType="submit" id="submit-postal-code" type="important" disabled={isFetching}>
                {WordingService.getWording('button', 'validate')}
              </Button>
            </div>
          </Col>
        </Row>
      </form>
    );
  }
}

LetterView.defaultProps = {
  goToErrorPage: () => { },
};

LetterView.propTypes = {
  /** Function to redirect to error page */
  goToErrorPage: PropTypes.func,
};

export default LetterView;
